import {Component, inject, LOCALE_ID, OnInit} from '@angular/core';
import {ToastModule} from 'primeng/toast';
import {registerLocaleData} from '@angular/common';
import localeIt from '@angular/common/locales/it';
import {RouterOutlet} from '@angular/router';
import {Button} from 'primeng/button';
import {ConfirmDialog} from 'primeng/confirmdialog';
import {ShortcutContext} from './shared/shortcuts/shortcut.context';
import {ShortcutHelpState} from './shared/shortcuts/shortcut-help.context';
import {SettingsStore} from './core/store/settings.store';
import {ShortcutHelpComponent} from './shared/shortcuts/shortcut-help.component';

@Component({
	selector: 'app-root',
	imports: [ToastModule, RouterOutlet, Button, ConfirmDialog, ShortcutHelpComponent],
	providers: [{ provide: LOCALE_ID, useValue: 'it-IT' }],
	templateUrl: './app.html',
	styleUrl: './app.css'
})
class App implements OnInit {
	private shortcuts = inject(ShortcutContext)
	private helpState = inject(ShortcutHelpState)
	private settingStore = inject(SettingsStore)

	constructor() {
		registerLocaleData(localeIt);
	}

	ngOnInit(): void {
		this.shortcuts.register({
			id: 'open-shortcut-help',
			description: 'Mostra scorciatoie',
			keys: ['MOD', '\\'],
			display: [
				{ kind: 'modifier', value: 'MOD' },
				{ kind: 'key', value: '\\' }
			],
			action: () => this.helpState.visible.set(!this.helpState.visible())
		});

		this.shortcuts.register({
			id: 'dark-mode',
			description: 'Attiva/Disattiva tema scuro',
			keys: ['MOD', 'K'],
			display: [
				{ kind: 'modifier', value: 'MOD' },
				{ kind: 'key', value: 'K' }
			],
			action: () => this.settingStore.setDarkTheme(!this.settingStore.darkTheme())
		});
	}
}

export default App
